import { Typography, styled } from '@mui/material';

const CardTitle = styled(Typography)({
  fontFamily: 'Lato, sans-serif',
  fontSize: '1.25rem'
});

export default CardTitle;
